export default {
  SHOW_APPLICATION_VIEW: "SHOW_APPLICATION_VIEW",
  HIDE_APPLICATION_VIEW: "HIDE_APPLICATION_VIEW",
};
